<template>
    <div id="relatedSymptomListId" class="answer-list-content related-symptom-list-related-symptoms">

        <!-- ----------------------------------------- -->
        <!-- RELATED SYMPTOM LIST -->
        <!-- ----------------------------------------- -->

        <div v-if="getCurrentAssessmentStatus === getAssessmentStatuses.RELATED_SYMPTOMS && getRelatedSymptomList" class="answer-items">

            <div v-for="(relatedSymptom, index) in getRelatedSymptomList"
                 :key="relatedSymptom.code"
                 :ref="'answer-item-'+relatedSymptom.code"
                 :id="'RELATED_S_' + relatedSymptom.code"
                 class="answer-item"
            >

                <v-checkbox
                    :label="relatedSymptom.name"
                    v-model="relatedSymptom.state"
                    :true-value="`${getRelatedSymptomStates.HAVE_SYMPTOM}`"
                    :false-value="`${getRelatedSymptomStates.NONE}`"
                    @change="handleChangeRelatedSymptom(relatedSymptom)"
                    :id="'RELATED_S_CHECKBOX_' + relatedSymptom.code"
                    hide-details
                ></v-checkbox>

            </div>
        </div>

        <v-btn v-if="getCurrentAssessmentStatus === getAssessmentStatuses.RELATED_SYMPTOMS && getRelatedSymptomList"
               @click.once="confirmSelectedRelatedSymptoms()"
               id="btnConfirmSelectedRelatedSymptoms"
               color="primary"
               class="btn confirm-related-symptoms"
               block
        >{{text("api.chatbot.btn.confirm")}}</v-btn>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import { mapGetters } from 'vuex';
    import Vue from "vue";

    export default {
        name: 'AnswerListRelatedSymptoms',

        data() {
            return {
                isConfirmBtnClickDisabled: false, // This will help us to prevent multiple clicks on Confirm button.
                radioButtonPfPlugin: Vue.RadioButtonPf.RadioButtonPfSvg
            }
        },

        computed: {
            ...mapGetters({
                getRelatedSymptomList: 'ChatBotStore/getRelatedSymptomList',
                getRelatedSymptomStates: 'ChatBotStore/getRelatedSymptomStates',
                getAssessmentStatuses: 'ChatBotStore/getAssessmentStatuses',
                getCurrentAssessmentStatus: 'ChatBotStore/getCurrentAssessmentStatus',
                getConversationMessageTypes: 'ChatBotStore/getConversationMessageTypes',
                getMustConfirmNoOtherSymptom: 'ChatBotStore/getMustConfirmNoOtherSymptom',
                getAppPropertyValue: 'TranslationStore/getAppPropertyValue'
            }),

            selectedRelatedSymptoms() {
                let selectedSymptomsArr = this.getRelatedSymptomList.reduce((selectedRelatedSymptoms, crtSymptom) => {
                    if (crtSymptom.state === this.getRelatedSymptomStates.HAVE_SYMPTOM) {
                        selectedRelatedSymptoms.push(crtSymptom);
                    }
                    return selectedRelatedSymptoms;
                }, []);

                return selectedSymptomsArr;
            },

            selectedRelatedSymptomNames() {
                let selectedSymptomNamesArr = this.getRelatedSymptomList.reduce((selectedRelatedSymptoms, crtSymptom) => {
                    if (crtSymptom.state === this.getRelatedSymptomStates.HAVE_SYMPTOM) {
                        selectedRelatedSymptoms.push(crtSymptom.name);
                    }
                    return selectedRelatedSymptoms;
                }, []);

                return selectedSymptomNamesArr;
            }
        },

        watch: {
            getRelatedSymptomList (newVal, oldVal) {

                this.isConfirmBtnClickDisabled = false; // Related symptom list has been updated, so we make sure that clicks are enabled.

                this.$nextTick(function () {
                    // setTimeout(() => {
                        this.$emit('onAnswerListUpdated');
                    // }, 1500);

                });
            }
        },

        methods: {

            handleChangeRelatedSymptom(changedRelatedSymptom){
                console.log("changedRelatedSymptom:", changedRelatedSymptom);

                if (changedRelatedSymptom.state === this.getRelatedSymptomStates.HAVE_SYMPTOM){
                    this.$store.dispatch("ChatBotStore/selectRelatedSymptom", {
                        "symptom": changedRelatedSymptom
                    });
                }
                else {
                    this.$store.dispatch("ChatBotStore/deselectRelatedSymptom", {
                        "symptom": changedRelatedSymptom
                    });
                }

                let that = this;
                setTimeout(function() {
                    let relatedSymptomsList = document.getElementById('relatedSymptomListId')
                    let relatedSymptoms = relatedSymptomsList.getElementsByClassName('answer-item');
                    for (let i = 0; i < relatedSymptoms.length; i++) {
                        let selectedRelatedSymptom = relatedSymptoms[i].getElementsByClassName('icon--checkbox');
                        if (selectedRelatedSymptom.length > 0) {

                            for (let j = 0; j < selectedRelatedSymptom.length; j++) {
                                selectedRelatedSymptom[j].innerHTML = that.radioButtonPfPlugin()
                            }

                        }
                    }
                }, 300)
            },


            confirmSelectedRelatedSymptoms () {

                if (this.isConfirmBtnClickDisabled === true) {
                    return; // Clicks on Confirm button are disabled, so do nothing else.
                }
                else {
                    this.isConfirmBtnClickDisabled = true; // Clicks on Confirm button were enabled until now. We disable them now (so no other clicks are possible), then execute the actions for current click.
                }

                this.$emit("onClickedAnswer");

                if (this.selectedRelatedSymptoms.length > 0) {
                    let clickedAnswerElem;
                    this.selectedRelatedSymptoms.forEach((crtSelectedRelatedSymptom) => {
                        clickedAnswerElem = this.$refs['answer-item-'+crtSelectedRelatedSymptom.code][0];
                        clickedAnswerElem.classList.add('answer-item-clicked');
                    });
                }

                this.$store.dispatch("ChatBotStore/confirmRelatedSymptoms", {
                    "selectedRelatedSymptoms": this.selectedRelatedSymptoms
                });
            }

        },

        mounted() {
            let that = this;
            setTimeout(function() {
                let relatedSumptomsList = document.getElementById('relatedSymptomListId')
                let relatedSymptoms = relatedSumptomsList.getElementsByClassName('answer-item');
                for (let i = 0; i < relatedSymptoms.length; i++) {
                    let selectedRelatedSymptom = relatedSymptoms[i].getElementsByClassName('icon--checkbox');
                    if (selectedRelatedSymptom.length > 0) {

                        for (let j = 0; j < selectedRelatedSymptom.length; j++) {
                            selectedRelatedSymptom[j].innerHTML = that.radioButtonPfPlugin();
                        }

                    }
                }
            }, 500)
        }
    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>
    .confirm-related-symptoms.btn {
        border-radius: 20px;
        height: 40px !important;
        font-weight: 400;

        // SMASSDEV - 1119
        font-size: $font-size-default;
        // word-spacing: $word-spacing-default;
        // line-height: $line-height-default;
        // letter-spacing: $letter-spacing-default;

        text-transform: none;
        color: $color-on-primary;
        box-shadow: none;
    }

    @media only screen and (max-width: 599px) {
        .confirm-related-symptoms.btn {
            margin: 20px 0 12px 0 !important;
        }
    }
    @media only screen and (min-width: 600px) {
        .confirm-related-symptoms.btn {
            margin: 36px 0 24px 0 !important;
        }
    }
</style>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/answer-list/AnswerListRelatedSymptoms.vue